<template>
  <div class="modal-root" v-if="isShowing">
    <div class="content-root" :style="size || ''">
      <div class="header-group">
        <div class="header-title">{{ title }}</div>
        <span class="close" @click="$emit('update:isShowing', false)"
          >&times;</span
        >
      </div>
      <div class="content-group">
        <div class="content">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    isShowing: Boolean,
    size: String
  }
};
</script>

<style scoped>
.modal-root {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}
.content-root {
  display: flex;
  flex-flow: column;
  width: 70vw;
  height: 97vh;
  background-color: rgba(255, 255, 255, 1);
  padding: 10px;
}
.header-group {
  display: flex;
  justify-content: space-between;
  height: 30px;
  border-bottom: 1px solid rgba(222, 226, 222, 0.5);
}
.header-title {
  font-size: 1.3em;
  font-weight: bold;
  text-transform: uppercase;
}
.content-group {
  overflow: auto;
}
.close {
  color: black;
  cursor: pointer;
  font-size: 50px;
  margin-top: -25px;
}
@media all and (max-width: 640px) {
  .content-root {
    width: 90vw;
    height: 90vh;
    margin-top: 25px;
  }
  .header-title {
    font-size: 1.1em;
  }
}
</style>
